import { capitalizeFirstLetterInAllWordsV2, getFormatedDate } from 'src/utils/utilityMethods';
import { IcpEntityType } from './types';

export const getValidIcpEntityTab = (tab: string): IcpEntityType => {
  return tab === 'account' || tab === 'persona' ? tab : 'account';
};

export const getICPValue = (val: string | number | boolean) => {
  if (val === null || val === undefined) return '';
  if(typeof val === 'string' && /\d{2}:\d{2}:\d{2}/.test(val)) {
    const dateChunk = val.split(' - ');
    if(dateChunk.length === 1){
      return `${getFormatedDate(dateChunk[0])}`;
    }
    return `${getFormatedDate(dateChunk[0])} → ${getFormatedDate(dateChunk[1])}`;
  }
  let value = val.toString().toLowerCase();
  if (value === 'custom ai signals') {
    return 'Custom AI Signals';
  }
  if (value === 'b2b' || value === 'b2c' || value === 'b2b vs b2c') {
    return value.toUpperCase();
  }
  value = value.replace('departmental_head_count_', '');
  if (/\d/.test(value)) {
    return value.toUpperCase();
  }
  return capitalizeFirstLetterInAllWordsV2(value);
};
